export default {
  validate: {
    empty: 'Field is empty',
    startWithAlphabetOrNumber:
      'Please input start with alphabet character or number',
    onlyLatinWithSpecialCharacter:
      'Please input latin character only and !@#$%^&*',
    limitCharacter: 'Maximum characters are %{count}',
  },
  delete_title: 'Delete Confirmation',
  remove_message: 'Are you sure you want to remove this %{name}',
  remove_title: 'Remove %{name}',
  remove_cw_message: 'Are you sure you want to remove this covered warrant',
  remove_cw_title: 'Remove covered warrant',
  invalid_name_title: 'Invalid Name',
  invalid_name_message:
    'The name you enter is invalid. Please choose a new one',
  server_error: 'Server error',
  exceed_limit_title: 'Exceed %{name} Limit',
  exceed_limit_create_message:
    'You cannot create more than %{count} %{name}. Please try again.',
  errorLimitWorkspace: {
    title: 'Workspace Limitation',
    content: 'You cannot create more than 10 workspaces. Please try again.',
  },

  titleErrorCreateNewLayout: 'Workspace Limitation',
  invalid_name_workspace: 'Invalid Name Workspace',
  server_error_modify_workspace: 'Server error edit workspace',

  errorLimitWatchList: {
    content: 'Exceed Ticker Limit',
    title: 'You cannot add more than 100 tickers on one watchlist',
  },

  errorExitTickerInWatchList: {
    title: 'Existed ticker',
    content: 'This ticker has existed  in this watchlist',
  },
  errorExistCWInWatchList: {
    title: 'Existed covered warrant',
    content: 'This covered warrant has existed  in this watchlist',
  },
  cannotCompare: 'Cannot Compare',
  cannotCompareMessage:
    'You cannot choose this ticker for comparing. Please try again!',
  cannotAddTickerCompare: 'Cannot Add Ticker',
  cannotAddTickerCompareMessage:
    'You cannot add more than 5 ticker for comparing. Please try again!',
};
